import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { BaseApiService } from './base-api.service';
import GraphqlService from '@services/graphql.service';
import { ImageService } from '@services/image.service';
import SavedViewService from '@services/saved-view.service';
import { SavedFilterService } from '@services/saved-filter.service';
import { ContactsService } from '@modules/contacts/contacts.service';
import { CustomObjectsService } from '@services/custom-objects.service';
import { PipelineService } from 'app/modules/projects/pipeline.service';
import { EngagementsService } from 'app/modules/engagements/engagements.service';
import { ProjectTemplateService } from 'app/modules/projects/project-template.service';

@Injectable({ providedIn: 'root' })
export class JupiterDataService {
  accountId: number = null;

  savedViewService = inject(SavedViewService);
  savedFilterService = inject(SavedFilterService);
  graphqlService = inject(GraphqlService);
  customObjectService = inject(CustomObjectsService);
  projectTemplateService = inject(ProjectTemplateService);
  engagementService = inject(EngagementsService);
  imageService = inject(ImageService);
  apiService = inject(BaseApiService);
  pipelineService = inject(PipelineService);
  contactsService = inject(ContactsService);
  httpClient = inject(HttpClient);
}
